import { useQuery } from "@tanstack/react-query";
import calendarEventApiClient, {
  CalendarEvent,
} from "../../../api/calendarEvent";

const useCalendarEventQuery = (calendarEventId: string) => {
  return useQuery<CalendarEvent | null>({
    queryKey: ["calendar-event", calendarEventId],
    queryFn: async () => {
      return await calendarEventApiClient.getCalendarEvent(calendarEventId);
    },
    enabled: !!calendarEventId,
  });
};

export default useCalendarEventQuery;
